import GenericPopup from '@/shared-components/popups/components/GenericPopup';

export default function PopupCertificateOfAuthenticity({ open, onClose }) {
  return (
    <GenericPopup open={open} opacity className="purchase-popup__coa" onClose={onClose}>
      <div style={{ padding: 20 }}>
        <h3 style={{ marginTop: 0 }}>Certificate of Authenticity</h3>
        <p style={{ color: 'var(--app-grey-color)' }}>
          This artwork may include a Certificate of Authenticity issued by the gallery.
        </p>
      </div>
    </GenericPopup>
  );
}